import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=66690858&scoped=true"
import script from "./EmptyData.vue?vue&type=script&lang=js"
export * from "./EmptyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66690858",
  null
  
)

export default component.exports